<template>
  <div>
    <div class="locw" v-if="dailies.length!=0">
      <div class="line" ></div>
      <recHead></recHead>
      <div v-for="(item, index) in dailies" @click="cliActItem(item.id)">
        <videoItem v-if="item.type==1" :key="index" :ref="`r${index}`" :baseObj="item" ></videoItem>
        <articleItem v-else :key="index" :ref="`r${index}`" :baseObj="item" ></articleItem>
      </div>

      <div class="bottom"></div>
    </div>
  </div>

</template>

<script>
import recHead from "./recHead";
import videoItem from "./videoItem";
import articleItem from "./articleItem";
import {getWebRecommendDailies} from "../../js/shareApp/daily";
import {Toast} from "vant";
import {utils} from "../../network/utils";
import {app} from "../../network/app/app";
import {actConfig} from "../../js/activity/actConfig";
import {actUtil} from "../../js/activity/util";

export default {
  name: "recommend",
  components:{
    recHead,
    videoItem,
    articleItem
  },
  props:{
    dailies:{
      type: Array,
    }
  },
  // data(){
  //   return {
  //     // dailies: []
  //   }
  // },
  mounted() {
    console.log('recommend mount')
  },
  created() {

  },
  methods:{
    cliActItem(id){
//是否处于分享
      if(app.getState()){
        // this.$router.push({path: '/shareApp/shareDaily/'+id})
        //app内打开，打开新的页面跳转
        // app.gotoUri('shareApp/shareDaily/'+id)
      }else{
        this.$router.push({path: '/shareApp/shareDaily/'+id})
        // this.$router.replace({path: '/share/shareActPersonPage/vote1/'+actConfig.getData().activityId+'/'+item.userId})
      }
    },
  },
}
</script>

<style scoped>
.locw{
  width: 990px;
  margin: auto;
  color: #30353d;
}
.line{
  width: 100%;
  border-bottom: 1px solid #b7b7b7;
}
.bottom{
  width: 100%;
  height: 130px;
}
</style>